import $http from "../../helpers/api";

// initial state
const state = {
  all: [],
  asf: [],
  certificate: []
};

// getters
const getters = {
  getAsf() {
    return state.asf;
  },
  getAll() {
    return state.all;
  },
  getCertificate() {
    return state.certificate;
  }
};

// actions
const actions = {
  getAllAsfs({ commit }, sortBy = 'id') {
    return new Promise((resolve, reject) => {
      $http.get("/asfs?includes[]=phones").then(resp => {
        let sortedData = resp.data.asfs.sort((a, b) => {
            if (!a.name || !b.name) return 0; // Evita erro caso a chave 'name' não exista
            return a.name.toString().localeCompare(b.name.toString(), 'pt-BR', { numeric: true });
        });

        let arr = sortedData.map((item, i) => ({
            id: item.id,
            name: item.name,
            vat: item.vat,
            phones: item.phones.map(o => o["phone"]).join(", ")
        }));

        commit("setAsfs", arr);
        resolve();
      }).catch(error => reject(error));
    });
  },
  getAsf({ commit }, asfId) {
    return new Promise(resolve => {
      $http
        .get("/asfs/" + asfId + "?includes[]=addresses&includes[]=phones&includes[]=assessments")
        .then(resp => {
          let arr = {
            id: resp.data.asf.id,
            name: resp.data.asf.name,
            vat: resp.data.asf.vat,
            addresses: resp.data.asf.addresses,
            phones: resp.data.asf.phones,
            answers: resp.data.asf.answers,
            certified: resp.data.asf.certified,
            initial_date: resp.data.asf.initial_date,
            expiry_date: resp.data.asf.expiry_date
          };
          commit("setAsf", arr);
          resolve();
        });
    });
  },
  downloadCertified({ commit }, asfId) {
    return new Promise(resolve => {
      $http
        .get("/asfs/" + asfId + "/certified")
        .then((resp) => {
          commit("setCertificate", resp.data);
          window.open(resp.data, '_blank');
        });
    });
  },
  addAsf(context, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("/asfs", { asf: data })
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editAsfs({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .put("/asfs/" + data.id, { asf: data })
        .then(resp => {
          commit("clearAsf");
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  searchAsfs(context, data) {
    return new Promise((resolve, reject) => {
      $http
        .get("/asfs", { params: data })
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteAsf({}, data) {
    return new Promise((resolve, reject) => {
      $http
        .delete("/asfs/" + data)
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  setCertificate(state, certificate) {
    state.certificate = certificate;
  },
  setAsfs(state, asfs) {
    state.all = asfs;
  },
  setAsf(state, asf) {
    state.asf = asf;
  },
  clearAsf(state) {
    state.asf = [];
  },
  clearAll(state) {
    state.all = [];
    state.asf = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
